import { publishWizardBackAriaLabel } from '@/features/instruments/lib/instrumentNavigation'

export function resolveShellBackAriaLabel(flags: {
  isInstrumentCreateInfo: boolean
  isInstrumentRouting: boolean
  isPublish: boolean
  isCampaignWizard: boolean
  campaignWizardStep?: 'setup' | 'goal-analysis' | 'lines-of-inquiry' | 'team-and-launch'
  isNewCampaignWizard?: boolean
  pathname?: string
}): string {
  if (flags.isInstrumentCreateInfo) return 'Back to instrument type selection'
  if (flags.isPublish) return publishWizardBackAriaLabel(flags.pathname ?? '')
  if (flags.isInstrumentRouting) return 'Back to question builder'
  if (flags.isCampaignWizard) {
    switch (flags.campaignWizardStep) {
      case 'team-and-launch':
        return 'Back to lines of inquiry'
      case 'lines-of-inquiry':
        return 'Back to goal analysis'
      case 'goal-analysis':
        return 'Back to campaign setup'
      case 'setup':
      default:
        return flags.isNewCampaignWizard ? 'Back to campaigns' : 'Back to campaign'
    }
  }
  return 'Back to campaign'
}

export function resolveWorkspaceBackTestId(flags: {
  isInstrumentRouting: boolean
  isPublish: boolean
  showInstrumentWorkspaceHeader: boolean
  isCampaignWizard: boolean
}): string {
  if (flags.isCampaignWizard) return 'campaign-wizard-app-back'
  if (flags.isPublish) return 'publish-app-back'
  if (flags.isInstrumentRouting) return 'routing-app-back'
  if (flags.showInstrumentWorkspaceHeader) return 'question-builder-app-back'
  return 'instruments-create-back'
}

export function resolveAppShellHeaderTestId(isInstrumentWorkspaceGutterPage: boolean): string {
  return isInstrumentWorkspaceGutterPage ? 'app-shell-header-rail' : 'app-shell-header-row'
}

export function resolveHeaderSearchValue(
  section: 'library' | 'campaigns' | 'sensemakers' | 'signalProviders' | null,
  campaignSearch: string,
  librarySearch: string,
  sensemakerSearch: string,
  signalProviderSearch: string,
): string {
  switch (section) {
    case 'campaigns':
      return campaignSearch
    case 'library':
      return librarySearch
    case 'sensemakers':
      return sensemakerSearch
    case 'signalProviders':
      return signalProviderSearch
    default:
      return ''
  }
}

export function resolveHeaderSearchChangeHandler(
  section: 'library' | 'campaigns' | 'sensemakers' | 'signalProviders' | null,
  setCampaignSearch: (value: string) => void,
  setLibrarySearch: (value: string) => void,
  setSensemakerSearch: (value: string) => void,
  setSignalProviderSearch: (value: string) => void,
): (value: string) => void {
  switch (section) {
    case 'campaigns':
      return setCampaignSearch
    case 'library':
      return setLibrarySearch
    case 'sensemakers':
      return setSensemakerSearch
    case 'signalProviders':
      return setSignalProviderSearch
    default:
      return () => undefined
  }
}
